module.exports = __webpack_public_path__ + "static/media/niroggyan.e60a35ff.svg";